import { useState, useEffect, createRef } from "react";
import { disableMapEvents } from "./utils/mapFunctions";
import CatalogueControl from "./widgets/CatalogueControl";
import LayerControl from "./widgets/LayerControl";
import LegendControl from "./widgets/LegendControl";
import FilterControl from "./widgets/FilterControl";
import ExternalControl from "./widgets/ExternalControl";
import DetailControl from "./widgets/DetailControl";
import DatasetsControl from "./widgets/DatasetsControl";

const LeftPanel = (props) => {
  const map = props.map;
  const panelRef = createRef();
  const [activeWidget, setActiveWidget] = useState(null);
  const [layers, setLayers] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [filters, setFilters] = useState({});
  const [showExternal, setShowExternal] = useState(false);
  const [showDetail, setShowDetail] = useState(null);
  const [showDatasets, setShowDatasets] = useState(null);

  useEffect(() => {
    disableMapEvents(panelRef);
  }, [panelRef]);

  useEffect(() => {
    setShowDetail(null);
    setShowDatasets(null);
    setShowFilter(false);
    setFilters({});
    setShowExternal(false);
    if (props.isMobile) {
      props.setActivePanel(activeWidget ? "left" : null);
    }
  }, [activeWidget, props]);

  const addLayer = (layer, url, id, title, name, opacity = 1, visibility = true, order = null) => {
    setLayers(prev => {
      if (prev.some(l => l.id === id)) return prev;

      const newLayer = { layer, url, id, title, name, opacity, visibility, order: order ?? prev.length };

      if (order === null) return [...prev, newLayer];

      const newLayers = [...prev];
      let inserted = false;
      for (let i = 0; i < newLayers.length; i++) {
        if ((newLayers[i].order ?? i) > order) {
          newLayers.splice(i, 0, newLayer);
          inserted = true;
          break;
        }
      }
      if (!inserted) newLayers.push(newLayer);

      return newLayers;
    });
  };

  const removeLayer = (layerToRemove) => {
    setLayers(prev => prev.filter(l => l.id !== layerToRemove.id));
  };

  const toggleActive = (newItem) => {
    setActiveWidget((prevItem) => (prevItem === newItem ? "" : newItem));
  };

  return (
    <div className="left-container">
      <div className="buttons-container buttons-container-left" style={{display: props.isMobile && activeWidget ? "none" : ""}}>
        <button className={"ccl-button ccl-button--default ccl-button--default-neg map-button" + (activeWidget === "Catalogue" ? " active" : "")} onClick={() => toggleActive("Catalogue")} aria-label="Catalogue">
          <i className="fa-solid fa-book"></i>
        </button>
        <button className={"ccl-button ccl-button--default ccl-button--default-neg map-button" + (activeWidget === "Layers" ? " active" : "")} onClick={() => toggleActive("Layers")} aria-label="Layers">
          <i className="fa-solid fa-layer-group"></i>
        </button>
        <button className={"ccl-button ccl-button--default ccl-button--default-neg map-button" + (activeWidget === "Legend" ? " active" : "")} onClick={() => toggleActive("Legend")} aria-label="Legend">
          <i className="fa-solid fa-list"></i>
        </button>
      </div>
      <div className="widget-panel widget-panel-left" ref={panelRef} style={{display: activeWidget ? "block" : "none", overflow: showDetail || showFilter ? "hidden" : ""}}>
        <div className="widget-title">
          {activeWidget}{activeWidget === "Layers" && ` (${layers.length})`}
          <button className="icon-button widget-close" onClick={() => setActiveWidget()} aria-label="Close">
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <CatalogueControl active={activeWidget === "Catalogue"} map={map} layers={layers} addLayer={addLayer} setShowDetail={setShowDetail} showDetail={showDetail} setShowDatasets={setShowDatasets} setShowFilter={setShowFilter} showFilter={showFilter} filters={filters} setFilters={setFilters} setShowExternal={setShowExternal}/>
        <LayerControl active={activeWidget === "Layers"} map={map} layers={layers} setLayers={setLayers} removeLayer={removeLayer} setShowDetail={setShowDetail} showDetail={showDetail}/>
        {activeWidget === "Legend" && <LegendControl map={map} layers={layers}/>}
      </div>
      {showDetail !== null && <DetailControl id={showDetail} setShowDetail={setShowDetail} setShowDatasets={setShowDatasets}/>}
      {showDatasets !== null && <DatasetsControl id={showDatasets} map={map} layers={layers} addLayer={addLayer} setShowDatasets={setShowDatasets}/>}
      {showFilter && <FilterControl setShowFilter={setShowFilter} filters={filters} setFilters={setFilters}/>}
      {showExternal && <ExternalControl map={map} layers={layers} addLayer={addLayer} setShowExternal={setShowExternal}/>}
    </div>
  );
};

export default LeftPanel;
